import React, { useContext, useState, ChangeEvent, useEffect } from "react";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import { toast } from "react-toastify";
import { Content, Header, Footer } from "../styles";

type DefaultBriefingProps = {
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    default_briefing: {
        name: "Briefig padrão",
        value: "",
        type: "texto",
    },
};

const Default = ({ nextStep, goToStep }: DefaultBriefingProps) => {
    const { values, confirmationStep, handleChange, setValues, updateValuesInLocalStorage } =
        useContext(MultiStepFormContext);

    const [defaultBriefing, setDefaultBriefing] = useState<string>(values?.extra?.default_briefing?.value || "");

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const briefingPlaceHolder = `Descreva aqui o que precisa que seja fotografado...\nQuantidade de itens/produtos:\nTipo de produtos/ensaios:\nQuantidade de fotos esperada:\nUso das fotos esperada:\nUso das fotos:tipo de iluminação desejada:`;

    const validateAndNextStep = () => {
        if (!defaultBriefing.length) {
            return toast.error("As informações do briefing precisam ser preenchidas!");
        }
        handleChange("briefing", defaultBriefing);

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", defaultBriefing);
    }, [defaultBriefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações de briefing</p>
                    <div className="bar" />
                    <TextareaInput
                        name="default_briefing"
                        value={defaultBriefing}
                        placeholder={briefingPlaceHolder}
                        rows={7}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setDefaultBriefing(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Default;
